/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model'
  ],
  function (
    $,
    mustache,
    pip
  ) {
    var view = {
      templates: {
        movingCalculator: $('#moving-calculator-template').html()
      },
      selectors: {
        movingCalculator: '#moving_calculator',
        button: '#moving-calculator__button'
      },
      updateDom: {
        movingCalculator: function updateDomMovingCalculator() {
          $(view.selectors.movingCalculator).html(view.render.movingCalculator)
        }
      },
      render: {
        movingCalculator: function movingCalculator() {
          return mustache.render(view.templates.movingCalculator)
        }
      },
      initEventListeners: function initEventListeners() {
        $(window.document).off('.moving-calculator');

        $(window.document).on('click.moving-calculator', view.selectors.button, function() {
          window.location.href = "http://hdmoving.com/";
        });
      },
      init: function initView() {
        if (shouldDisplayMovingCalculator()) {
          view.updateDom.movingCalculator();
          view.initEventListeners();
        }
      }
    };

    function shouldDisplayMovingCalculator() {
      return !!(pip.movingCalculatorEligible)
    }

    return {
      init: function init() {
        view.init()
      },
      view: view
    }
  });




}.call(window));